import React from 'react';
import PropTypes from 'prop-types';
import { Pattern } from 'utilities/components/pattern/component/view';

export const PatternInnerView = ({ data, color, isReverse }) => (
    <Pattern data={ data } color={ color } isReverse={ isReverse } />
);

PatternInnerView.propTypes = {
    data: PropTypes.oneOfType([PropTypes.object]).isRequired,
    color: PropTypes.string,
    isReverse: PropTypes.bool
};

PatternInnerView.defaultProps = {
    color: ' #4a548c',
    isReverse: false
};